import {
    CONNECTION_QUALITY_PING_RECEIVED,
    CONNECTION_QUALITY_BELOW_THRESHOLD,
    CONNECTION_QUALITY_EXCEEDS_THRESHOLD,
    DISMISS_CONNECTION_QUALITY_WARNING,
    DISPLAY_CONNECTION_QUALITY_WARNING
} from "../../../LiveSwitch/liveSwitchActionTypes";
import { ApiError } from "../../sharedTypes";
import * as types from "./actionTypes";

export function apiErrorOccurred(error: ApiError, endUserMessage: string) {
    error.endUserErrorMessage = endUserMessage;
    return {
        type: types.API_ERROR_OCCURRED as typeof types.API_ERROR_OCCURRED,
        error,
    };
}

export function connectionQualityPingReceived(value: number, drops: number){
    return {
        type: CONNECTION_QUALITY_PING_RECEIVED as typeof CONNECTION_QUALITY_PING_RECEIVED,
        connectionValue: value,
        consecutiveDrops: drops
    };
}

export function addConnectionWarning(value: number, drops: number) {
    return {
        type: CONNECTION_QUALITY_BELOW_THRESHOLD as typeof CONNECTION_QUALITY_BELOW_THRESHOLD,
        connectionValue: value,
        consecutiveDrops: drops
    }
}

export function clearConnectionWarnings(value: number, drops: number) {
    return {
        type: CONNECTION_QUALITY_EXCEEDS_THRESHOLD as typeof CONNECTION_QUALITY_EXCEEDS_THRESHOLD,
        connectionValue: value,
        consecutiveDrops: drops
    }
}

export function dismissConnectionWarnings(value: number, drops: number) {
    return {
        type: DISMISS_CONNECTION_QUALITY_WARNING as typeof DISMISS_CONNECTION_QUALITY_WARNING,
        connectionValue: value,
        consecutiveDrops: drops
    }
}

export function displayConnectionWarnings(value: number, drops: number) {
    return {
        type: DISPLAY_CONNECTION_QUALITY_WARNING as typeof DISPLAY_CONNECTION_QUALITY_WARNING,
        connectionValue: value,
        consecutiveDrops: drops
    }
}

export interface APIStatusMessageAction {
    type: typeof types.BEGIN_API_CALL | typeof types.API_CALL_ERROR;
}

export function beginApiCall(): APIStatusMessageAction {
    return { type: types.BEGIN_API_CALL };
}

export function apiCallError(): APIStatusMessageAction {
    return { type: types.API_CALL_ERROR };
}


export type SharedActions =
    | ReturnType<typeof connectionQualityPingReceived>
    | ReturnType<typeof addConnectionWarning>
    | ReturnType<typeof clearConnectionWarnings>
    | ReturnType<typeof dismissConnectionWarnings>
    | ReturnType<typeof displayConnectionWarnings>
    | ReturnType<typeof beginApiCall>
    | ReturnType<typeof apiCallError>;